import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { User } from 'lib-shared-types-api';
import * as React from 'react';
import { shallowEqual } from 'react-redux';

import { transferToAgentActions } from 'components/shared/transferToAgentModal/actions/transferToAgentModal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import styles from './requestTransferAssistButton.module.scss';

export type RequestTransferAssistButtonProps = {
  user: User;
};

export const RequestTransferAssistButton = ({
  user,
}: RequestTransferAssistButtonProps): React.ReactElement => {
  const dispatch = useAppDispatch();
  const { assignedAgent, metaConversation } = useAppSelector(
    (state) => ({
      assignedAgent:
        state.conversation.metaConversation.conversation.assignment?.agent,
      metaConversation: state.conversation.metaConversation,
    }),
    shallowEqual,
  );

  const requestTransferAssist = async ({ id }) => {
    try {
      await bindActionToPromise(
        dispatch,
        transferToAgentActions.transferToAgentAssistedRequest,
      )({
        requestToUser: { id },
        requestFromAgent: assignedAgent,
        metaConversation: metaConversation,
      });
    } catch (error) {
      console.warn(error);
    }
  };

  const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    requestTransferAssist({ id: user.id });
  };

  return (
    <Tooltip content="Call first" side="right">
      <IconButton
        className={styles.transferToAssistButton}
        icon="phone"
        variant="tertiary"
        onClick={handleOnClick}
      />
    </Tooltip>
  );
};
